import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { NoNetworkDialogBodyComponent } from '../no-network-dialog-body/no-network-dialog-body.component';
import { NavigationService } from '../../../../navigation/navigation.service';
import { ConnectionMonitorService } from '../../../services/connection-monitor.service';

@Component({
    selector: 'app-no-network-dialog',
    template: ''
})
export class NoNetworkDialogComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription;

    dialogRef: MatDialogRef<NoNetworkDialogBodyComponent>;

    constructor(
        private readonly connectionService: ConnectionMonitorService,
        private readonly navigationService: NavigationService,
        public dialog: MatDialog
    ) {}

    ngOnInit() {
        this.subscriptions = this.connectionService.online$.subscribe(isConnected => {
            if (isConnected) {
                this.closeDialog();
                this.navigationService.refresh();
            } else {
                this.openDialog();
            }
        });
    }

    openDialog() {
        this.dialogRef = this.dialog.open(NoNetworkDialogBodyComponent, {
            disableClose: true,
            closeOnNavigation: false,
            hasBackdrop: true
        });
    }

    closeDialog() {
        if (this.dialogRef) {
            this.dialogRef.close();
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
